import React from "react";
import { useStyles } from "./Button.styles";
import SubmitButton from "../../SubmitButton";

type GuardiaButtonProps = {
  variant?: "success" | "neutral" | "error" | "outline" | "outline-error" | "gray" | "gradient";
  size?: "small" | "medium" | "large";
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
};

const Button: React.FC<GuardiaButtonProps> = ({
  variant = "neutral",
  size = "medium",
  type = "button",
  disabled,
  loading,
  onClick,
  children,
  className,
}) => {
  const classes = useStyles();

  const colorMap: { [key: string]: any } = {
    neutral: "default",
    success: "default",
    error: "default",
    outline: "default",
    "outline-error": "default",
    gray: "default",
    gradient: "default",
  };

  const variantClassKey = variant.replace(/-([a-z])/g, (_m, p1) => p1.toUpperCase());
  const classOverride = (classes as any)[variantClassKey] || "";

  return (
    <SubmitButton
      size={size}
      disabled={disabled}
      loading={loading}
      type={type}
      onClick={onClick}
      color={colorMap[variant]}
      className={classOverride + (className ? " " + className : "")}
    >
      {children}
    </SubmitButton>
  );
};

export default Button;
